import React from "react";
import { Sidebar, MobileHeader, MobileBottomNav } from "@/components/Nav";
import AIDrawer from "@/components/AIDrawer";

export default function AppShell({ children }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Sidebar />
      <MobileHeader />
      <main className="md:ml-[240px] px-4 md:px-8 py-6 md:py-10 pb-24 md:pb-10 max-w-7xl md:mx-0" data-testid="main-content">
        {children}
      </main>
      <MobileBottomNav />
      <AIDrawer />
    </div>
  );
}
